import { render } from "./DialogAlert.vue?vue&type=template&id=af510212&scoped=true"
import script from "./DialogAlert.vue?vue&type=script&lang=js"
export * from "./DialogAlert.vue?vue&type=script&lang=js"

import "./DialogAlert.vue?vue&type=style&index=0&id=af510212&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af510212"]])

export default __exports__